import { render, staticRenderFns } from "./uiFold.vue?vue&type=template&id=91046154&scoped=true"
import script from "./uiFold.vue?vue&type=script&lang=js"
export * from "./uiFold.vue?vue&type=script&lang=js"
import style0 from "./uiFold.vue?vue&type=style&index=0&id=91046154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91046154",
  null
  
)

export default component.exports